import type { Tone } from './StatusChip';

/** Narrows the server's RAG string for components that only accept RAG. */
export function asRag(rag: string | null | undefined): 'green' | 'amber' | 'red' | 'grey' {
  return rag === 'green' || rag === 'amber' || rag === 'red' ? rag : 'grey';
}

/** Maps the server's RAG strings onto chip tones. */
export function ragTone(rag: string | null | undefined): Tone {
  switch (rag) {
    case 'green':
      return 'green';
    case 'amber':
      return 'amber';
    case 'red':
      return 'red';
    default:
      return 'grey';
  }
}
